export default function PageNotFound() {
  return (
    <>
      <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="text-base font-semibold text-pink-500">404 - Không tìm thấy trang</p>
          <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
            Oops! Trang bạn tìm kiếm không tồn tại
          </h1>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Có thể đường dẫn đã bị thay đổi hoặc sản phẩm không còn tồn tại. Hãy quay lại trang chủ để tiếp tục mua sắm nhé!
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/"
              className="rounded-md bg-pink-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
            >
              Quay về trang chủ
            </a>
            <a href="tel:0784992000" className="text-sm font-semibold text-gray-900 hover:underline">
              Liên hệ bộ phận hỗ trợ&nbsp;<span aria-hidden="true">&rarr;</span>
            </a>
          </div>
        </div>
      </main>

    </>
  )
}
